(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/pain-point-slider"],{

/***/ "./src/assets/js/pain-point-slider.js":
/*!********************************************!*\
  !*** ./src/assets/js/pain-point-slider.js ***!
  \********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var PainPointSlider = /*#__PURE__*/function (_HTMLElement) {
  function PainPointSlider() {
    var _this;
    _classCallCheck(this, PainPointSlider);
    _this = _callSuper(this, PainPointSlider);
    _this.topSlider = _this.querySelector('.pain-point-slider__top');
    _this.middleSlider = _this.querySelector('.pain-point-slider__middle');
    _this.bottomSlider = _this.querySelector('.pain-point-slider__bottom');
    return _this;
  }
  _inherits(PainPointSlider, _HTMLElement);
  return _createClass(PainPointSlider, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.activeSliderTop = new Swiper(this.topSlider, {
        slidesPerView: 3,
        loop: false,
        centeredSlides: false,
        preloadSlides: 15,
        loopedSlides: 15,
        spaceBetween: 10,
        watchSlidesProgress: true,
        slideToClickedSlide: true
      });
      this.activeSliderMiddle = new Swiper(this.middleSlider, {
        slidesPerView: 1.2,
        spaceBetween: 10,
        draggable: true,
        breakpoints: {
          768: {
            slidesPerView: 1
          }
        }
      });
      this.activeSliderBottom = new Swiper(this.bottomSlider, {
        slidesPerView: 1,
        spaceBetween: 10,
        draggable: true
      });

      // Function to update all sliders
      var updateAllSliders = function updateAllSliders(index) {
        _this2.activeSliderTop.slideTo(index);
        _this2.activeSliderMiddle.slideTo(index);
        _this2.activeSliderBottom.slideTo(index);
        _this2.updateTopSliderActiveClass(index);
      };

      // Update active class on top slider
      this.updateTopSliderActiveClass = function (activeIndex) {
        _this2.activeSliderTop.slides.forEach(function (slide, index) {
          if (index === activeIndex) {
            slide.classList.add('custom-slide-active');
          } else {
            slide.classList.remove('custom-slide-active');
          }
        });
      };

      // Add click event listeners to top slider slides
      this.activeSliderTop.slides.forEach(function (slide, index) {
        slide.addEventListener('click', function () {
          updateAllSliders(index);
        });
      });

      // Add event listeners for all sliders
      [this.activeSliderTop, this.activeSliderMiddle, this.activeSliderBottom].forEach(function (slider) {
        slider.on('slideChange', function () {
          updateAllSliders(slider.activeIndex);
        });
      });

      // Additional event listener for top slider to handle scroll
      this.activeSliderTop.on('transitionEnd', function () {
        _this2.updateTopSliderActiveClass(_this2.activeSliderTop.activeIndex);
      });

      // Initial setup
      this.updateTopSliderActiveClass(0);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          return _this3.setupSlider();
        });
      } else {
        this.setupSlider();
      }
    }
  }, {
    key: "setupSlider",
    value: function setupSlider() {
      var _this4 = this;
      var checkSwiper = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          _this4.init();
          clearInterval(checkSwiper);
        }
      }, 100); // check every 100 milliseconds
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('pain-point-slider')) {
  customElements.define('pain-point-slider', PainPointSlider);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/pain-point-slider.js"));
/******/ }
]);